module.exports = __webpack_public_path__ + "801b5ef1f9bb57d51f68022eb7a8107a.svg";